import { createServerFn } from '@tanstack/react-start';
import { z } from 'zod';
import { BetaRegistrantsBoard } from '@api/BoardSDK';

export const createRegistration = createServerFn({ method: 'POST' })
  .validator(
    z.object({
      name: z.string(),
      email: z.string().email(),
      mondayUrl: z.string(),
      useCase: z.string(),
      whoOwnsThisAccount: z.string(),
    })
  )
  .handler(async ({ data }) => {
    const board = new BetaRegistrantsBoard();
    
    const today = new Date().toISOString().split('T')[0];
    
    const result = await board
      .item()
      .create({
        name: data.name,
        email: data.email,
        mondayUrl: data.mondayUrl,
        useCase: data.useCase,
        whoOwnsThisAccount: data.whoOwnsThisAccount,
        submittedDate: today,
        reviewStatus: 'New',
        feedbackForm: { url: 'https://wkf.ms/4lRaKOz', label: 'Feedback Form' },
      })
      .execute();

    return { success: true, itemId: result.id };
  });
